import React from 'react';
import FieldContainer from 'components/pure/utils/form/FieldContainer';
import CardReasonSchemeEntry from 'records/CardReasonSchemeEntry';
import ConstValues from 'utils/const';
import DeletableInput from 'components/pure/utils/DeletableInput';
import {scorecardTypes} from 'records/Scorecard';
import './CardReasonSchemeEntryFormTable.styl';

// TODO: a must be replaced with button and eslint ignore must be removed
/* eslint jsx-a11y/anchor-is-valid: "off", no-script-url: "off" */
export default class CardReasonSchemeEntryForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.lastReasonInput = null;
    this.addReason = this.addReason.bind(this);
  }

  addReason(reason) {
    const {entry} = this.props;
    const newReasons = entry.reasons.push('');
    const newEntry = new CardReasonSchemeEntry({
      id: entry.id,
      point: entry.point,
      reasons: newReasons,
    });

    this.props.onChange(newEntry);
    requestAnimationFrame(() => {
      const input = this.lastReasonInput;
      input && input.focus();
    });
  }

  onChange(index, newReason) {
    const {entry} = this.props;

    const newReasons = entry.reasons.splice(index, 1, newReason);
    const newEntry = new CardReasonSchemeEntry({
      point: entry.point,
      score: entry.score,
      reasons: newReasons,
    });
    this.props.onChange(newEntry);
  }

  onDeleteReason(index) {
    const {entry} = this.props;

    const newEntry = new CardReasonSchemeEntry({
      point: entry.point,
      score: entry.score,
      reasons: entry.reasons.splice(index, 1),
    });
    this.props.onChange(newEntry);
  }

  onNext() {
    this.addReason();
  }

  getLabelForPoint(point, scoringScheme) {
    if (point === null) return 'N/A';
    // TODO add support for custom labels here
    // see labelOrDefault code in 'records/Scorecard'
    const answer = scorecardTypes[scoringScheme].answers.find(({value}) => value === point);
    return answer && answer.label;
  }

  renderAddButtons(entry) {
    return (
      <a href="javascript:" className="add-reason" onClick={this.addReason}>
        {entry.reasons.size === 0 ? 'Add Reason' : 'Add Another Reason'}
      </a>
    );
  }

  render() {
    const {entry} = this.props;
    const pointStyle = {
      backgroundColor: ConstValues.scorecardResultScoreToHoverColor.get(String(entry.point)),
    };

    return (
      <tr key={entry.point}>
        <td className="point-cell">
          <div className="point" style={pointStyle}>
            {this.getLabelForPoint(entry.point, this.props.scoringScheme)}
          </div>
        </td>
        <td className="reasons-row">
          {entry.reasons.size === 0 ? (
            <div>
              <span className="none-text">None required</span>
              {this.renderAddButtons(entry)}
            </div>
          ) : (
            <div className={'reasons-list'}>
              {entry.reasons.map((reason, i) => (
                <div className={'reason'} key={reason + i}>
                  <FieldContainer>
                    <DeletableInput
                      value={reason || ''}
                      inputRef={ref => (this.lastReasonInput = ref)}
                      onChange={value => this.onChange(i, value)}
                      onDelete={() => this.onDeleteReason(i)}
                      onNext={() => this.onNext(i)}
                      placeholder={'Enter Reason...'}
                    />
                  </FieldContainer>
                </div>
              ))}
              {this.renderAddButtons(entry)}
            </div>
          )}
        </td>
      </tr>
    );
  }
}
